import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Internal dependencies.
 */
import CookiesWithIssues from '../cookiesWithIssues';
const SiteMapCookiesWithIssues = ({ cookies, path, }) => {
    return (_jsx(CookiesWithIssues, { cookies: cookies, selectedSite: null, hostName: path }));
};
export default SiteMapCookiesWithIssues;
